/* WD UX RC: collection page redesign helpers (3 Oct 2026). Progressive enhancement only: every control works without JS
   (Show more is a real link to ?page=N, filters submit the form). Delegated listeners survive the theme's section re-render. */
(function () {
  if (window.__wdColl) return; window.__wdColl = true;
  document.documentElement.classList.add('wd-js');

  function sectionUrl(href, sectionId) {
    var u = new URL(href, location.href); u.searchParams.set('section_id', sectionId); return u;
  }

  // "Show all N" in long filter lists
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-wd-fmore]'); if (!b) return;
    var box = b.closest('.wd-fmore'); var open = box.classList.toggle('is-open');
    b.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (!b.dataset.label) b.dataset.label = b.textContent;
    b.textContent = open ? 'Show fewer' : b.dataset.label;
  });

  // "Show more" -> append the next page's cards (Section Rendering API), keep numbered pages underneath
  document.addEventListener('click', function (e) {
    var a = e.target.closest('a[data-wd-more]'); if (!a) return;
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.button > 0) return;
    var coll = a.closest('[data-wd-coll]'); var list = coll && coll.querySelector('product-list'); if (!list) return;
    e.preventDefault(); a.setAttribute('aria-busy', 'true');
    var href = a.href;
    fetch(sectionUrl(href, a.dataset.sectionId).toString(), { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var newList = doc.querySelector('[data-wd-coll] product-list'); var newPager = doc.querySelector('[data-wd-pager]');
        if (!newList) throw new Error('no list');
        var first = null;
        Array.prototype.slice.call(newList.children).forEach(function (el) {
          var node = document.importNode(el, true);
          node.removeAttribute('reveal-on-scroll');
          node.querySelectorAll('[reveal-on-scroll]').forEach(function (n) { n.removeAttribute('reveal-on-scroll'); });
          list.appendChild(node); if (!first) first = node;
        });
        var pager = coll.querySelector('[data-wd-pager]');
        if (pager && newPager) pager.replaceWith(document.importNode(newPager, true));
        try { var clean = new URL(href); clean.searchParams.delete('section_id'); history.replaceState(history.state, '', clean.toString()); } catch (err) {}
        var link = first && first.querySelector('a[href]'); if (link) link.focus({ preventScroll: true });
      })
      .catch(function () { location.href = href; });
  });

  // Drawer apply: don't add the default sort to the URL (QA: applying gave ?sort_by=manual&filter...). The theme builds the URL
  // from new FormData(form), which fires "formdata" (not bubbling, so listen in the capture phase). sort_by is dropped only when
  // it equals the collection's default sort and the current URL has no sort_by, so an explicit sort choice is kept.
  document.addEventListener('formdata', function (e) {
    var form = e.target; if (!form || form.id !== 'facets-drawer-form') return;
    var host = document.querySelector('[data-wd-default-sort]'); var def = host && host.getAttribute('data-wd-default-sort');
    var fd = e.formData; if (!def || !fd || !fd.has('sort_by')) return;
    if (fd.get('sort_by') === def && !new URLSearchParams(location.search).has('sort_by')) fd.delete('sort_by');
  }, true);

  // RC3 (5 Oct 2026): the drawer's live "Show N watches" count was removed (Alex's no-product-counts rule). The apply button
  // now always reads "Show results"; filters still apply on submit as before.
})();
